import { render, staticRenderFns } from "./dealerDetail.vue?vue&type=template&id=c146bbd0&scoped=true&"
import script from "./dealerDetail.vue?vue&type=script&lang=js&"
export * from "./dealerDetail.vue?vue&type=script&lang=js&"
import style0 from "./dealerDetail.vue?vue&type=style&index=0&id=c146bbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146bbd0",
  null
  
)

export default component.exports